import { env } from "../libs/utils/env";

export const MIN_MONTHLY_AMOUNT = env.float(
    process.env.REACT_APP_MIN_MONTHLY_AMOUNT,
    40
);

export const MAX_MONTHLY_AMOUNT = env.float(
    process.env.REACT_APP_MAX_MONTHLY_AMOUNT,
    3_000_000
);
